module.exports = __webpack_public_path__ + "img/icon_fb.f81acc87.png";